import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISyncSocialChannelsV1Request } from './sync-social-channels-v1-request';
import type { ISyncSocialChannelsV1Response } from './sync-social-channels-v1-response';
import { syncSocialChannelsV1ResponseSchema } from './sync-social-channels-v1-response';

export async function syncSocialChannelsV1Api(
  body: ISyncSocialChannelsV1Request,
): Promise<IValidatedResponse<ISyncSocialChannelsV1Response>> {
  return postRequest<ISyncSocialChannelsV1Response>({
    path: '/sys/social/v1/channels/sync',
    body,
    schema: syncSocialChannelsV1ResponseSchema,
  });
}
